<template>
    <div class="tw:relative" :class="props.customClass" :data-cy="props.dataCy">
        <div v-if="props.loading" class="tw:absolute tw:inset-0 tw:bg-white/50 tw:z-10 tw:flex tw:items-center tw:justify-center tw:transition-opacity">
            <svg class="tw:animate-spin tw:h-8 tw:w-8 tw:text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="tw:opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="tw:opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
            </svg>
        </div>
        <GChart
            v-if="props.data.length > 1"
            :type="props.type"
            :data="props.data"
            :options="mergedOptions"
            :style="{ height: `${props.height}px`, width: '100%' }"
        />
        <div v-else class="tw:h-full tw:flex tw:justify-center tw:items-center tw:text-gray-400 tw:py-3" :style="{ height: `${props.height}px` }">
            No hay datos disponibles
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { GChart } from 'vue-google-charts';

    const props = defineProps({
        type: {
            type: String,
            default: 'ColumnChart'
        },
        data: {
            type: Array,
            default: () => []
        },
        options: {
            type: Object,
            default: () => ({})
        },
        height: {
            type: Number,
            default: 300
        },
        customClass: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        dataCy: {
            type: String,
            default: ''
        }
    });

    const defaultOptions = {
        chartArea: { width: '90%', height: '80%' },
        legend: { position: 'none' },
        animation: { duration: 300, easing: 'out', startup: false }
    };

    const mergedOptions = computed(() => ({
        ...defaultOptions,
        ...props.options
    }));
</script>